import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-manage-users-tree-view',
  templateUrl: './manage-users-tree-view.component.html',
  styleUrls: ['./manage-users-tree-view.css'],
  encapsulation: ViewEncapsulation.None
})
export class ManageUsersTreeViewComponent implements OnInit {

  constructor(private _service: ApiService, private _commonservice: CommonService) {
    _commonservice.myAccount.subscribe((res: any) => {
      this.currentUserData.avatarUrl = res.avatarUrl;
    });
  }
  currentUserData: any;
  objectKey: any
  getTreeUsers: any;

  ngOnInit(): void {
    let logginUserStringValue = localStorage.getItem('currentUser');
    if (logginUserStringValue) {
      this.currentUserData = JSON.parse(logginUserStringValue);
    }
    this.getManageUserTreeView();

  }

  nodes: any = [
    {
      name: '',
      cssClass: 'ngx-org-ceo',
      title: '',
      image: '',
      childs: [{
        image: '',
      }],
    },

  ]
  parentIMage: any;

  //  Fetching the data here to display as Tree view here
  getManageUserTreeView() {
    try {
      this._service.getService(this._service.API_URL.getManageUserTreeView).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.getTreeUsers = response.data;
          this.nodes[0].name = response.data.name;
          this.nodes[0].title = response.data.title;
          this.getDownloadPreSignedurlForParent(response.data.avatarUrl)
          this.nodes[0].childs = response.data.admins;
          this.nodes[0].childs.forEach((element: any) => {
            if (element.avatarUrl) {
              this.getDownloadPreSignedurl(element);
            } else {
              element.image = './assets/images/images.png';
            }
          });

        }

      })
    } catch (error) {

    }
  }

  //  To Display the Image for the User we are Downloading the presigned Url and Here and Assigning to the Image Tag
  getDownloadPreSignedurl(element: any) {
    try {
      if (element.avatarUrl && element.avatarUrl != null) {
        this._service.getService(this._service.API_URL.getDownloadPreSignedurl + "?objectKey=" + element.avatarUrl).subscribe((response) => {
          if (response && response.status.code === 200) {
            element.avatarUrl = response.data.avatarUrl;
            this.nodes[0].childs.forEach((element: any) => {
              element.childs.forEach((e: any) => {
                this.getCHildImages(e)
              });
              element.image = element.avatarUrl ? element.avatarUrl : './assets/images/images.png';
            });
          }
        })
      }
    } catch (error) {

    }
  }


  getCHildImages(elem: any) {
    try {
      if (elem.avatarUrl && elem.avatarUrl != null) {

        this._service.getService(this._service.API_URL.getDownloadPreSignedurl + "?objectKey=" + elem.avatarUrl).subscribe((response) => {
          if (response && response.status.code === 200) {
            elem.image = response.data.avatarUrl;

          } else {
            elem.image = './assets/images/images.png';
          }
        })
      } else {
        elem.image = './assets/images/images.png';
      }
    } catch (error) {

    }
  }

  //  To Display the Image for the User we are Downloading the presigned Url and Here and Assigning to the Image Tag
  getDownloadPreSignedurlForParent(element: any) {
    try {
      if (element && element != null) {
        this._service.getService(this._service.API_URL.getDownloadPreSignedurl + "?objectKey=" + element).subscribe((response) => {
          if (response && response.status.code === 200) {
            element = response.data.avatarUrl;
            this.nodes[0].image = element;
          } else {
            this.nodes[0].image = './assets/images/images.png'
          }
        })
      } else {
        this.nodes[0].image = './assets/images/images.png'
      }
    } catch (error) {
      console.log(error);
    }
  }
}


export class Org {
  name = '';
  childs = [];
}